import {
  FileCheck2,
  HeartHandshake,
  ShieldCheck,
  Target,
  Users
} from "lucide-react";
import { whyChooseItems } from "../../../data/homepage";
import Reveal from "../../ui/Reveal";
import Section from "../../ui/Section";

const cardIcons = [Target, Users, FileCheck2, HeartHandshake, ShieldCheck];

function WhyChooseSection() {
  return (
    <Section
      tone="dark"
      className="overflow-hidden bg-[#001b3d] py-24 sm:py-28"
      containerClassName="max-w-7xl"
    >
      <div className="grid gap-14 lg:grid-cols-[0.95fr_1.05fr]">
        <div className="lg:sticky lg:top-40">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold">
            Why TheCareerSpace
          </p>
          <h2 className="mt-5 text-4xl font-semibold leading-tight text-white sm:text-5xl">
            Grounded counselling,
            <span className="block italic text-brand-gold">not generic advice.</span>
          </h2>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-white/90 sm:text-base">
            Our approach combines profile-based strategy with transparent communication so students and parents can decide with confidence.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {whyChooseItems.map((item, index) => {
            const Icon = cardIcons[index % cardIcons.length];

            return (
              <Reveal key={item.title} delay={index * 0.08}>
                <article className="h-full border border-[#2b4468] bg-[#0a2f5e] p-6 transition-all duration-300 hover:bg-[#0c3b75]">
                  <Icon className="h-5 w-5 text-brand-gold" />
                  <h3 className="mt-4 text-xl font-semibold text-white">{item.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-white/90">{item.description}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </Section>
  );
}

export default WhyChooseSection;
